import { useEffect, useRef } from "react";

export const useClickTracking = (onClick: () => void, enabled: boolean) => {
  const onClickRef = useRef(onClick);
  const enabledRef = useRef(enabled);

  // Keep refs fresh
  useEffect(() => {
    onClickRef.current = onClick;
    enabledRef.current = enabled;
  }, [onClick, enabled]);

  useEffect(() => {
    if (!enabledRef.current) return;

    const handleClick = () => {
      if (enabledRef.current && onClickRef.current) {
        onClickRef.current();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
};
